export default __webpack_public_path__ + "static/media/school-1.d8e56e16.png";